import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './field-error.scss';

export interface FieldErrorProps {
  className?: string;
  /**
   * DOM `id` used by `aria-errormessage` on the associated input.
   */
  id?: string;
  /**
   * Validation error message to display. Renders nothing when absent.
   */
  message?: string;
}

/**
 * Inline validation error message rendered beneath a form field.
 *
 * Uses `role="alert"` so screen readers announce errors as they appear.
 * Each `Field.*` component renders this internally and wires the input's
 * `aria-errormessage` attribute to the error element's `id`.
 */
export const FieldError = ({ className, id, message }: FieldErrorProps) => {
  useStyles(s);

  if (!message) return null;

  return (
    <span id={id} className={classNames(s.root, className)} role="alert">
      {message}
    </span>
  );
};
